"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var load_themed_styles_1 = require("@microsoft/load-themed-styles");
load_themed_styles_1.loadStyles([{ "rawString": ".editingInput_aec7d74f{border:0px;outline:none;width:100%}.editingInput_aec7d74f::-ms-clear{display:none}.editingContainer_aec7d74f{margin:4px}\n" }]);
exports.editingInput = "editingInput_aec7d74f";
exports.editingContainer = "editingContainer_aec7d74f";
//# sourceMappingURL=EditingItem.scss.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib/components/SelectedItemsList/SelectedPeopleList/Items/EditingItem.scss.js
// module id = 1648
// module chunks = 0